<template>
  <div class="organiz-tree">
    <div class="tree-node" v-show="parentExpand || node.pid<=0" v-for="(node, index) in nodes" :key="index" :class="{'top': node.pid==0,'last':node.children.length==0,'left':index==0,'right':nodes.length-1==index}">
      <span class="tree-node-item" :class="{'left':index==0,'right':nodes.length-1==index}">
        <Poptip trigger="hover">
        {{node.name}}
          <div slot="content">
            <span class="icon" @click="onClickEdit(node)" v-if="$menu.isPower('structure', 'edit')"><Icon type="md-create" size="30"></Icon></span>
            <span class="icon" @click="onClickPlus(node)" v-if="$menu.isPower('structure', 'edit')"><Icon type="md-add" size="30"></Icon></span>
            <Poptip
              confirm
              title="您确认删除这条内容吗？"
              width="200"
              style="text-align:left"
              @on-ok="onClickDel(node)" v-if="$menu.isPower('structure', 'del') && node.id>1">
                <span class="icon" style="text-align:center"><Icon type="md-trash" size="30"></Icon></span>
            </Poptip>
          </div>
        </Poptip>
      </span>
      <span class="tree-node-line" v-if="node.children.length>0" style="font-size:20px">
        <span v-show="!node.expand" @click="onClickExpand(node)"><Icon type="md-add-circle"></Icon></span>
        <span v-show="node.expand" @click="onClickExpand(node)"><Icon type="md-remove-circle"></Icon></span>
      </span>
      <organiz-tree :nodes="node.children" :parentExpand="!!node.expand" class="children" @onAdd="onClickPlus" @onEdit="onClickEdit" @onDel="onClickDel" @onExpand="onClickExpand" :inputShow="show"></organiz-tree>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OrganizTree',
  props: {
    nodes: Array,
    nodeShow: Boolean,
    inputShow: Boolean,
    parentExpand: Boolean,
    value: Boolean,
    onAdd: {
      type: Function,
      default: null
    },
    onEdit: {
      type: Function,
      default: null
    },
    onDel: {
      type: Function,
      default: null
    },
    onExpand: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      show: false,
      childrenShow: false
    }
  },
  watch: {
  },
  mounted () {

  },
  methods: {
    onClickExpand (node) {
      this.$emit('onExpand', node)
    },
    onClickPlus (node) {
      this.$emit('onAdd', node)
    },
    onClickEdit (node) {
      this.$emit('onEdit', node)
    },
    onClickDel (node) {
      this.$emit('onDel', node)
    },
    setShow (val) {
      this.$parent.childrenShow = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .organiz-tree{
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;/*flex-start | flex-end | center | space-between | space-around;*/
    align-items: flex-start;
    align-content: center;
    position: relative;
    /*padding: 10px 20px 0;*/
  }
  .organiz-tree.tree-expand>.tree-node{
    display: block !important;
  }
  .tree-node{
    padding:5px 10px;
    display:inline-block;
    text-align: center;
    margin-bottom: 20px;
    position: relative;
  }
  .tree-node.left:after{left:50%;}
  .tree-node.right:after{display: none;}
  .tree-node .tree-node-item{
    width: 240px;
    white-space: nowrap;
  }
  .tree-node .tree-node .tree-node-item{
    width:34px;
    white-space: normal;
  }
  .tree-node-item{
    border-radius: 4px;
    font-size: 16px;
    background-color: #fff;
    border:1px solid #ccc;
    display: inline-block;
    padding: 5px;
    margin-bottom: 15px;
  }
  .tree-node-item:hover{
    position: relative;
    z-index: 1000;
  }
  .tree-node-item:hover .node-plus{
    display: block
  }
  .node-plus{
    width: 100%;
    display: none;
    color: #999;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 0;
    font-size: 14px;
    line-height: 14px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .node-plus .icon{
    border: 1px solid #ccc;
    border-radius: 14px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    display: inline-block;
    background-color: #fff;
    font-size: 14px;
    color: #f00;
    margin: 5px 0;
  }
  .tree-node-item:after{
    content: '';
    width: 1px;
    height: 16px;
    background-color: #ccc;
    position: absolute;
    top: -10px;
    left: 50%;
  }
  .tree-node-item:before{
    content: '';
    width: 1px;
    height: 16px;
    background-color: #ccc;
    position: absolute;
    bottom: -16px;
    left: 50%;
  }
  .top>.tree-node-item:after{display: none;}
  .last>.tree-node-item:before{display: none;}
  .tree-node-line{
    width: 100%;
    display: block;
    height: 30px;
    margin: 0 auto;
    border-radius: 4px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
  }
</style>
